/**
 * 深拷贝
 * @param obj 拷贝对象
 */
export const deepCopy = (obj: any) : any => {
    // 检查是否为对象
    if (typeof obj !== 'object' || obj === null) {
        return obj; // 如果不是对象，则直接返回
    }

    // 创建一个新的对象或数组，根据原始对象的类型
    const copy: any = Array.isArray(obj) ? [] : {};

    // 遍历原始对象的所有属性
    for (let key in obj) {
        // 使用递归复制子对象的属性值
        copy[key] = deepCopy(obj[key]);
    }

    return copy;
}

/**
 * 根据特定属性值查找对应的 JSON 对象
 * @param array 对象数组
 * @param propertyName 具体key
 * @param propertyValue 具体值
 */
export const findObjectByPropertyValue = (array: any, propertyName: string, propertyValue: any) : any => {
    for (let obj of array) {
        if (obj[propertyName] === propertyValue) {
            return obj; // 如果找到匹配的对象，则返回该对象
        }
    }
    return null; // 如果未找到匹配的对象，则返回 null
}

/**
 * 首字母大写
 * @param string 字符串
 */
export const capitalizeFirstLetter = (string: string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

/**
 * 时间戳格式化
 * @param timestamp 时间戳
 */
export const formattedDate = (timestamp: number): string => {
    const date = new Date(timestamp);

    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份从0开始
    const day = date.getDate().toString().padStart(2, '0');
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}
